<div class="main-content">
  <div class="content-container">
    <div class="page-header">
      <h1 class="page-title">User Profile</h1>
      <p class="page-subtitle">
        View your account information and associated sold-to accounts
      </p>
    </div>
    @if (profileDetailsForm) {
      <form [formGroup]="profileDetailsForm">
        <section class="profile-section">
          <div class="form-grid">
            <div class="form-group">
              <label class="form-label">{{ 'KnbrProfile.label.firstName' | cxTranslate }}</label>
              <input type="text" class="form-input" formControlName="firstName">
            </div>
            <div class="form-group">
              <label class="form-label">{{ 'KnbrProfile.label.lastName' | cxTranslate }}</label>
              <input type="text" class="form-input" formControlName="lastName" >
            </div>
          </div>
          <div class="form-grid">
            <div class="form-group">
              <label class="form-label">{{ 'KnbrProfile.label.preferredName' | cxTranslate }}</label>
              <input type="text" class="form-input" formControlName="preferredName" >
            </div>
            <div class="form-group">
              <label class="form-label">{{ 'KnbrProfile.label.businessEmail' | cxTranslate }}</label>
              <input type="email" class="form-input" formControlName="businessEmail">
            </div>
          </div>
          <div class="form-grid">
            <div class="form-group">
              <label class="form-label">{{ 'KnbrProfile.label.role' | cxTranslate }}</label>
              <input type="text" class="form-input" formControlName="role" >
            </div>
            <div></div>
          </div>
          <div class="form-grid four-columns">
            <div class="form-group">
              <label class="form-label">{{ 'KnbrProfile.label.businessPhone' | cxTranslate }}</label>
              <input type="text" class="form-input" formControlName="businessPhone">
            </div>
            <div class="form-group">
              <label class="form-label">{{ 'KnbrProfile.label.extension' | cxTranslate }}</label>
              <input type="text" class="form-input" formControlName="extension">
            </div>
            <div class="form-group">
              <label class="form-label">{{ 'KnbrProfile.label.businessCell' | cxTranslate }}</label>
              <input type="text" class="form-input" formControlName="businessCell" >
            </div>
            <div class="form-group">
              <label class="form-label">{{ 'KnbrProfile.label.alternateCell' | cxTranslate }}</label>
              <input type="text" class="form-input" formControlName="alternateCell" >
            </div>
          </div>
        </section>
        <section class="soldto-section">
          <div class="section-header">
            <h2 class="section-title">Associated Sold-To Accounts</h2>
            <p class="section-subtitle">
              Your accessible customer accounts and billing information
            </p>
          </div>
          <div class="table-container">
            <table class="soldto-table">
              <thead>
                <tr>
                  <th>Payer #</th>
                  <th>Payer Name</th>
                  <th>Account #</th>
                  <th>Account Name</th>
                  <th>Location</th>
                </tr>
              </thead>
              <tbody>
                @for (customer of customerListData; track customer) {
                  <tr>
                    <td>{{ customer.payerId }}</td>
                    <td>{{ customer.payerName }}</td>
                    <td>{{ customer.customerNumber }}</td>
                    <td>{{ customer.customerName }}</td>
                    <td>{{ customer.addressLine2 }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </section>
      </form>
    }
  </div>
</div>
